import { ReactNode } from 'react'

type ActorHeaderProps = {
  title: ReactNode
  middle?: ReactNode
  action?: ReactNode
}

const ActorHeader = ({ title, middle, action }: ActorHeaderProps) => {
  if (middle) {
    return (
      <div className='flex h-6 items-center gap-1'>
        <div className='min-w-0 w-40 max-w-40 shrink-0 px-1 text-xs text-foreground leading-[14px]'>
          {title}
        </div>
        <div className='min-w-0 grow text-xs leading-[14px]'>{middle}</div>
        {action ? (
          <div className='flex shrink-0 items-center pr-1'>{action}</div>
        ) : null}
      </div>
    )
  }

  return (
    <div className='h-6 px-1 flex items-center justify-between gap-2'>
      <div className='min-w-0 text-xs text-foreground leading-[14px]'>
        {title}
      </div>
      <div className='shrink-0 flex items-center'>{action}</div>
    </div>
  )
}

export default ActorHeader
